import { fork } from 'redux-saga/effects'
import UserSaga from './user'
import CampaignSaga from './campaign'
import MissionSaga from './mission'
import PeopleLog from './people_log'
import Prizes from './prizes'
import user_feed_back from './user_feedback'
import app from './app'
import firebase from './firebase'
import router from './router'

const sagas = [
  UserSaga,
  CampaignSaga,
  MissionSaga,
  PeopleLog,
  Prizes,
  user_feed_back,
  app,
  firebase,
  router,
]

export default function* root() {
  yield sagas.map(saga => saga.map(watcher => fork(watcher)))
}



// WEBPACK FOOTER //
// ./src/sagas/index.jsx